module.exports = __webpack_public_path__ + "img/logo-company.003b67e6.png";